import { IToken, IUser } from "@core/models";
import jwtDecode from "jwt-decode";
import { isFilled, isObjectEmpty } from "./type.utils";

export const getInitials = (name: string) => {
  let initials = name.match(/\b\w/g) || [];
  return ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
};

export const ucFirst = (name: string | undefined) => {
  if (undefined !== name) {
    return name.charAt(0).toUpperCase() + name.slice(1).toLocaleLowerCase();
  } else {
    return '';
  }

}

export const getFirstName = (user: IUser) => {
  if (isFilled(user?.apelido)) {
    return ucFirst(user?.apelido);
  }

  if (isFilled(user?.nome)) {
    return ucFirst(user?.nome?.split(' ').at(0));
  }

  return ucFirst('colaborador');
}

export const getName = (user: (IUser & { initials: string; }) | null) => {
  if (isFilled(user?.apelido)) {
    return ucFirst(user?.apelido);
  }

  if (isFilled(user?.nome)) {
    return ucFirst(user?.nome?.split(' ').at(0));
  }

  return ucFirst('colaborador');
};

export const podeAcessarPerformanceProdutos = (user: (IUser & { initials: string; }) | null) => {
  if (isObjectEmpty(user)) {
    return false;
  }
  return user?.role.includes('PERFORMANCE_PRODUTOS');
}


export const decodeToken = (token: string) => jwtDecode<IToken>(token);
